import { resolveResponsiveFactor } from '../../resolvers/ComposedResolvers';
import resolveResponsiveValue from '../../resolvers/ResponsiveValueResolver';
export default function resolveHeight(theme, screenWidth, heightSupport) {
    var result = {};
    if (heightSupport.height !== undefined) {
        result.height = resolveResponsiveFactor(theme, screenWidth, heightSupport.height);
    }
    if (heightSupport.height100) {
        var height100 = resolveResponsiveValue(theme, screenWidth, heightSupport.height100);
        if (height100) {
            result.height = '100%';
        }
    }
    if (heightSupport.maxHeight !== undefined) {
        result.maxHeight = resolveResponsiveFactor(theme, screenWidth, heightSupport.maxHeight);
    }
    if (heightSupport.maxHeight100) {
        var maxHeight100 = resolveResponsiveValue(theme, screenWidth, heightSupport.maxHeight100);
        if (maxHeight100) {
            result.maxHeight = '100%';
        }
    }
    if (heightSupport.minHeight !== undefined) {
        result.minHeight = resolveResponsiveFactor(theme, screenWidth, heightSupport.minHeight);
    }
    if (heightSupport.minHeight100) {
        var minHeight100 = resolveResponsiveValue(theme, screenWidth, heightSupport.minHeight100);
        if (minHeight100) {
            result.minHeight = '100%';
        }
    }
    return result;
}
//# sourceMappingURL=HeightResolver.js.map